
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import singleServiceTime from '@xt/client/experimental/server-time'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class StudyRecord extends Vue {
  dataList: Array<{
    count: string
    description: string
    unit: string
  }> = [
    {
      count: 'learnTime',
      description: '已学习',
      unit: '小时'
    },
    {
      count: 'weekLearnTime',
      description: '周学习',
      unit: '分钟'
    },
    {
      count: 'continueDays',
      description: '连续学习',
      unit: '天'
    }
  ]

  get updateTime() {
    return singleServiceTime.getServerTime('moment').subtract(2, 'day').format('YYYY.MM.DD')
  }

  get PageStore() {
    return this.$store.$myV2.Center
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
